import reducer from "./reducers";

import * as cobrosOps from "./operations";
import * as cobrosTypes from "./types";
import * as cobrosSelectores from "./selectors";

export { cobrosOps, cobrosTypes, cobrosSelectores };

export default reducer;



// WEBPACK FOOTER //
// ./src/ducks/cobros/index.js